// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomerEndpoint } from './CustomerEndpoint';
import {
  CustomerEndpointFromJSON,
  CustomerEndpointFromJSONTyped,
  CustomerEndpointToJSON,
  CustomerEndpointToJSONTyped,
} from './CustomerEndpoint';
import type { NetworkServiceDetails } from './NetworkServiceDetails';
import {
  NetworkServiceDetailsFromJSON,
  NetworkServiceDetailsFromJSONTyped,
  NetworkServiceDetailsToJSON,
  NetworkServiceDetailsToJSONTyped,
} from './NetworkServiceDetails';

/**
 *
 * @export
 * @interface CustomerEnvironmentState
 */
export interface CustomerEnvironmentState {
  /**
   *
   * @type {NetworkServiceDetails}
   * @memberof CustomerEnvironmentState
   */
  targetService?: NetworkServiceDetails;
  /**
   * Customer-submitted endpoint IDs and their connection states, keyed by endpoint ID.
   * @type {{ [key: string]: CustomerEndpoint; }}
   * @memberof CustomerEnvironmentState
   */
  configuredEndpoints?: { [key: string]: CustomerEndpoint };
  /**
   * Derived connection status based on accepted/rejected/other endpoint counts.
   * @type {string}
   * @memberof CustomerEnvironmentState
   */
  overallState?: CustomerEnvironmentStateOverallStateEnum;
}

/**
 * @export
 */
export const CustomerEnvironmentStateOverallStateEnum = {
  NoEndpoints: 'no_endpoints',
  Pending: 'pending',
  Connected: 'connected',
  PartiallyConnected: 'partially_connected',
  Disconnected: 'disconnected',
} as const;
export type CustomerEnvironmentStateOverallStateEnum =
  (typeof CustomerEnvironmentStateOverallStateEnum)[keyof typeof CustomerEnvironmentStateOverallStateEnum];

/**
 * Check if a given object implements the CustomerEnvironmentState interface.
 */
export function instanceOfCustomerEnvironmentState(
  value: object,
): value is CustomerEnvironmentState {
  return true;
}

export function CustomerEnvironmentStateFromJSON(
  json: any,
): CustomerEnvironmentState {
  return CustomerEnvironmentStateFromJSONTyped(json, false);
}

export function CustomerEnvironmentStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomerEnvironmentState {
  if (json == null) {
    return json;
  }
  return {
    targetService:
      json['target_service'] == null
        ? undefined
        : NetworkServiceDetailsFromJSON(json['target_service']),
    configuredEndpoints:
      json['configured_endpoints'] == null
        ? undefined
        : mapValues(json['configured_endpoints'], CustomerEndpointFromJSON),
    overallState:
      json['overall_state'] == null ? undefined : json['overall_state'],
  };
}

export function CustomerEnvironmentStateToJSON(
  json: any,
): CustomerEnvironmentState {
  return CustomerEnvironmentStateToJSONTyped(json, false);
}

export function CustomerEnvironmentStateToJSONTyped(
  value?: CustomerEnvironmentState | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    target_service: NetworkServiceDetailsToJSON(value['targetService']),
    configured_endpoints:
      value['configuredEndpoints'] == null
        ? undefined
        : mapValues(value['configuredEndpoints'], CustomerEndpointToJSON),
    overall_state: value['overallState'],
  };
}
